import PropTypes from 'prop-types'

import Tooltip from '@/components/generics/Tooltip'

import * as S from './styles'

const Switch = ({
  checked = false,
  openLabel = '',
  closeLabel = '',
  onChange,
  disabled = false,
  tooltip = { disabled: true, text: '', placement: '' },
}) => {
  return (
    <S.SwitchWrapper>
      <S.Label id="poc-status-label" isChecked={checked}>
        {checked ? openLabel : closeLabel}
      </S.Label>

      <Tooltip
        target={
          <S.Switcher htmlFor="checkbox-poc-status">
            <S.Input
              id="checkbox-poc-status"
              name="poc-status"
              onChange={onChange}
              checked={checked}
              type="checkbox"
              data-testid="switch-store-availability"
              disabled={disabled}
            />
            <S.Slider isChecked={checked} isDisabled={disabled} />
          </S.Switcher>
        }
        disabled={tooltip.disabled}
        data-testid="switch-store-availability-tooltip"
        placement={tooltip.placement}
      >
        {tooltip.text}
      </Tooltip>
    </S.SwitchWrapper>
  )
}

Switch.propTypes = {
  checked: PropTypes.bool,
  openLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.shape({
    disabled: PropTypes.bool,
    text: PropTypes.string,
    placement: PropTypes.string,
  }),
}

export default Switch
